import { CatSkeleton } from '@blocks-react/components/Skeleton';
import styles from '../../MyEquipment.module.scss';

export const VirtualLoader = ({ gapForScroll }: { gapForScroll: string }) => {
  return (
    <div className={`${styles['virtualized_wrapper_loader']} ${gapForScroll}`}>
      <CatSkeleton size="xxl" data-testid="virtualized_skeleton" />
    </div>
  );
};
